type DataLayerEvent = Record<string, unknown>;

declare global {
    interface Window {
        dataLayer: Array<Record<string, unknown>>;
    }
}

export function pushDataLayerEvent(
    event: DataLayerEvent,
    options?: {
        preserveEcommerce?: boolean;
    }
) {
    window.dataLayer = window.dataLayer || [];

    // Clear previous ecommerce object unless explicitly preserved
    if (!options?.preserveEcommerce) {
        window.dataLayer.push({ ecommerce: null });
    }

    window.dataLayer.push(event);

    console.log('[analytics] dataLayer push:', event);
}

export function dispatchAnalyticsEvent(event: DataLayerEvent) {
    try {
        const isInsideIframe = window.self !== window.parent;

        if (isInsideIframe) {
            window.parent.postMessage(event, '*');

            console.log('[analytics] posted to parent:', event);

            return;
        }

        pushDataLayerEvent(event, {
            preserveEcommerce: true,
        });
    } catch (error) {
        console.error('[analytics] failed to dispatch event:', error);
    }
}